import React from 'react';
import { Card, Text, Group, Stack } from '@mantine/core';

interface RecommendedTest {
  'CPT Code': string;
  Container: string;
  'Price (AED)': string;
  'Sample Type': string;
  TAT: string;
  'Test ID': number;
  'Test Name': string;
  reason: string;
}

interface RecommendedTestCardProps {
  test: RecommendedTest;
}

const RecommendedTestCard: React.FC<RecommendedTestCardProps> = ({ test }) => (
  <Card shadow="sm" padding="lg" radius="md" withBorder mb="md">
    <Stack>
      <Text fw={700} size="lg">
        {test['Test Name']}
      </Text>
      <Group>
        <Text fw={500}>Cost:</Text>
        <Text>{test['Price (AED)']}</Text>
      </Group>
      <Group>
        <Text fw={500}>Results Available In</Text>
        <Text>{test['TAT']}</Text>
      </Group>
      <Text fw={500}>Why This Test Is Recommended:</Text>
      <Text>{test.reason}</Text>
    </Stack>
  </Card>
);

export default RecommendedTestCard;
